<template>
  <!--v-loading="loadingFlag"-->
  <div class="vg_wrapper">
    <div class="vd_edhea vg_button_group">
      <editHeader
        :btn="btn"
        :isShow="isShow"
        :strForm="qutaForm"
        @closeEdit="closeEdit"
        @openEdit="openEdit"
        @submit="submit('qutaForm')"
      />
      <div v-if="isShow" class="vd_export">
        <el-button size="small" type="primary" @click="buttonRefresh()">刷新</el-button>
      </div>
    </div>

    <el-form ref="qutaForm" :disabled="true" :model="qutaForm" :rules="rules" label-width="120px" size="mini">
      <el-row>
        <el-col :md="16">
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="委托打样单号" prop="requ_no">
                <el-input v-model="qutaForm.requ_no" clearable disabled maxlength="10" placeholder="请填写委托打样单号" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="报价单号" prop="quta_no">
                <el-input v-model="qutaForm.quta_no" clearable disabled maxlength="10" placeholder="请填写报价单号" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="我司货号" prop="smpl_no">
                <el-input v-model="qutaForm.smpl_nos" clearable disabled maxlength="10" placeholder="请填写我司货号" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="样品名称" prop="smpl_name">
                <el-input v-model="qutaForm.smpl_name" clearable disabled maxlength="10" placeholder="请填写样品名称" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="含运费" prop="smpl_frei_flag">
                <el-radio v-model="qutaForm.smpl_frei_flag" :label="1" @change="containFreight">是</el-radio>
                <el-radio v-model="qutaForm.smpl_frei_flag" :label="0" @change="containFreight">否</el-radio>
              </el-form-item>
            </el-col>
            <el-col :md="6">
              <el-form-item label="更改号" prop="smpl_suffix">
                <el-input v-model="qutaForm.smpl_suffix" disabled placeholder="暂无" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="6">
              <el-form-item label="版本号" prop="version_number">
                <el-input v-model="qutaForm.version_number" disabled placeholder="暂无"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="打样部门" prop="belo_dept_name">
                <el-input v-model="qutaForm.belo_dept_name" clearable disabled maxlength="10" placeholder="请填写打样部门" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="样品类型" prop="smpl_type">
                <el-select v-model="qutaForm.smpl_type" clearable disabled placeholder="请选择样品类型" size="small">
                  <el-option v-for="item in smplType" :key="`smpl_type${item.id}`" :label="item.label" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="产品尺寸" prop="smpl_spec">
                <el-input v-model="qutaForm.smpl_spec" clearable maxlength="10" placeholder="请填写产品尺寸" show-word-limit></el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="客户货号" prop="smpl_cust_no">
                <el-input v-model="qutaForm.smpl_cust_no" clearable disabled maxlength="10" placeholder="请填写客户货号" show-word-limit>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="皮壳重量" prop="smpl_skin_weight">
                <el-input
                  v-model="qutaForm.smpl_skin_weight"
                  clearable
                  maxlength="11"
                  placeholder="请填写皮壳重量"
                  show-word-limit
                  @blur="qutaForm.smpl_skin_weight = helper.retain1(qutaForm.smpl_skin_weight, 2, 100000000)"
                  @input="qutaForm.smpl_skin_weight = helper.keepTNum1(qutaForm.smpl_skin_weight)"
                >
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="样品重量" prop="smpl_weight">
                <el-input
                  v-model="qutaForm.smpl_weight"
                  clearable
                  disabled
                  maxlength="30"
                  placeholder="请填写样品重量"
                  show-word-limit
                  @blur="qutaForm.smpl_weight = helper.retain1(qutaForm.smpl_weight, 2, 100000000)"
                  @input="qutaForm.smpl_weight = helper.keepTNum1(qutaForm.smpl_weight)"
                >
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="纸箱长度" prop="smpl_box_l">
                <el-input
                  v-model="qutaForm.smpl_box_l"
                  clearable
                  maxlength="10"
                  placeholder="请填写纸箱长度"
                  show-word-limit
                  @change="smplBoxLChange"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="塑料袋长度" prop="smpl_bag_l">
                <el-input
                  v-model="qutaForm.smpl_bag_l"
                  clearable
                  maxlength="10"
                  placeholder="请填写塑料袋长度"
                  show-word-limit
                  @change="smplBagLChange"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="纸箱宽度" prop="smpl_box_w">
                <el-input
                  v-model="qutaForm.smpl_box_w"
                  clearable
                  maxlength="10"
                  placeholder="请填写纸箱宽度"
                  show-word-limit
                  @change="smplBoxWChange"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="塑料袋宽度" prop="smpl_bag_w">
                <el-input
                  v-model="qutaForm.smpl_bag_w"
                  clearable
                  maxlength="10"
                  placeholder="请填写塑料袋宽度"
                  show-word-limit
                  @change="smplBagWChange"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="纸箱高度" prop="smpl_box_h">
                <el-input
                  v-model="qutaForm.smpl_box_h"
                  clearable
                  maxlength="10"
                  placeholder="请填写纸箱高度"
                  show-word-limit
                  @change="smplBoxHChange"
                >
                  <template slot="append">cm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="装袋数" prop="smpl_qpb">
                <el-input
                  v-model="qutaForm.smpl_qpb"
                  clearable
                  maxlength="10"
                  placeholder="请填写装袋数"
                  show-word-limit
                  @change="smplQpbChange"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="vg_mb_5">
            <el-col :md="12">
              <el-form-item label="采购总核价" prop="quta_price">
                <el-input v-model="qutaForm.quta_price" disabled placeholder="请填写采购总合价" show-word-limit> </el-input>
              </el-form-item>
            </el-col>
            <el-col :md="12">
              <el-form-item label="采购核价工资" prop="quta_prsalary">
                <el-input
                  v-model="qutaForm.quta_prsalary"
                  clearable
                  disabled
                  maxlength="10"
                  placeholder="请填写采购核价工资"
                  show-word-limit
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
        <el-col :md="8">
          <el-form-item label="样品图片">
            <el-upload :action="uploadUrl" :data="dataBody" :show-file-list="false" class="avatar-uploader" disabled drag>
              <imgPopover v-if="qutaForm.imge_id" :imgeUrl="qutaForm.imge_url" :imgeUrlO="qutaForm.imge_urlO"></imgPopover>
              <i v-else class="el-icon-upload avatar-uploader-icon vg_pointer" size="40px"></i>
              <!-- <i
                v-else
                class="el-icon-plus avatar-uploader-icon vg_pointer"
                :class="{ vd_cussor: isShow }"
              ></i> -->
            </el-upload>
            <span>仅支持jpg、png、jpeg格式且大小不能超过10MB</span>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="标签" prop="tags">
            <el-select v-model="qutaForm.tags" allow-create default-first-option disabled filterable multiple placeholder="请输入">
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="装箱数" prop="smpl_qpc">
            <el-input v-model="qutaForm.smpl_qpc" clearable maxlength="10" placeholder="请填写装箱数" show-word-limit @change="qpcChange">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8">
          <el-form-item label="起订量" prop="smpl_moq">
            <el-input v-model="qutaForm.smpl_moq" clearable maxlength="10" placeholder="请填写起订量" show-word-limit></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="vd_solidDiv1"></div>
      <el-form :disabled="isShow" :model="qutaForm" :rules="rules" label-width="120px" size="mini">
        <div>
          <el-row :gutter="20" class="vg_mb_8">
            <el-col :md="12">
              <el-button size="mini" type="primary" @click="addConfirmFactory">新增</el-button>
              <el-button size="mini" type="danger" @click="deleteConfirmFactory">删除</el-button>
              <search-table
                ref="searchTable"
                :columnMove="false"
                :columns="theTradedFactoryProperties"
                :data="theTradedFactoryData"
                :headerCellClassName="'auto'"
                :is-show="isShow"
                :need-pagination="false"
                :need-search="false"
                :tableRowKey="'id'"
                @selection-change="handleSelectionChange"
              >
                <template v-slot:supp_abbr="scope">
                  <el-select
                    v-model="scope.row.supp_abbr"
                    filterable
                    placeholder="选选择"
                    size="small"
                    @change="val => suppAbbrChange(val, scope.row)"
                  >
                    <el-option v-for="item in confirmFactorySuppAbbrList" :key="item" :label="item" :value="item"> </el-option>
                  </el-select>
                </template>
              </search-table>
            </el-col>
            <el-col :md="12">
              <div>
                <el-row style="height: 200px">
                  <el-col :md="24">各工厂人工工资:</el-col>
                  <el-col v-for="(item, index) in qutaForm.factoryList" :key="'form' + item.supp_abbr + index" :md="8">
                    <el-form-item :label="item.supp_abbr" :prop="'cost_price_rate'">
                      <el-input
                        v-model="item.cost_price_rate"
                        :disabled="item.supp_abbr === '打样间'"
                        maxlength="11"
                        placeholder="暂无"
                        style="width: 120px"
                        @blur="item.cost_price_rate = helper.calcPrice(item.cost_price_rate, 4, 10000)"
                        @input="item.cost_price_rate = helper.keepTNum1(item.cost_price_rate)"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row style="height: 200px">
                  <el-col :md="24">各工厂总价:</el-col>
                  <el-col v-for="(item, index) in qutaForm.factoryList" :key="'form2' + item.supp_abbr + index" :md="8">
                    <el-form-item :label="item.supp_abbr" :prop="'priceInd_tax'">
                      <el-input v-model="item.priceInd_tax" disabled placeholder="暂无" style="width: 120px"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </div>
            </el-col>
          </el-row>
          <div style="display: flex">
            <el-select v-model="factoryList" filterable multiple placeholder="选择工厂后确定" size="small" style="width: 300px">
              <el-option v-for="item in erpSuppList" :key="item.label" :label="item.label" :value="item.label"> </el-option>
            </el-select>
            <el-button size="small" type="primary" @click="addTab(factoryList)">确定</el-button>
          </div>
          <el-tabs v-model="editableTabsValue" size="mini" @tab-remove="removeTab" @tab-click="tabClick">
            <el-tab-pane
              v-for="(item, index) in qutaForm.factoryList.filter(x => x.destroy_flag !== 1)"
              :key="item.supp_abbr + index"
              :closable="item.supp_abbr !== '打样间'"
              :label="item.supp_abbr"
              :name="item.supp_abbr"
            >
              <el-form :disabled="item.supp_abbr === '打样间'" :model="qutaForm" :rules="rules" label-width="120px" size="mini">
                <!--原材料 辅助材料 配件信息 -->
                <el-tabs v-model="activeName" :disabled="true" class="vd_eltab vd_buttom">
                  <el-tab-pane :key="index + 'first'" :name="index + 'first'" label="原材料">
                    <QutaRawMater ref="QutaRawMater" :formIndex="index" :qutaForm="qutaForm.factoryList[index]"></QutaRawMater>
                  </el-tab-pane>
                  <el-tab-pane :key="index + 'second'" :name="index + 'second'" label="辅助材料">
                    <QutaAuxiliary ref="QutaAuxiliary" :formIndex="index" :qutaForm="qutaForm.factoryList[index]"></QutaAuxiliary>
                  </el-tab-pane>
                  <el-tab-pane :key="index + 'fourth'" :name="index + 'fourth'" label="配件信息">
                    <QutaPartList
                      ref="QutaPartList"
                      :formIndex="index"
                      :qutaForm="qutaForm.factoryList[index]"
                      @calcPart="rateChange"
                    ></QutaPartList>
                  </el-tab-pane>
                </el-tabs>
                <!--成本价\税点\含税金额\税额合计-->
                <el-row class="vg_mb_16">
                  <el-col :md="14">
                    <QutaParameter :formIndex="index" :qutaForm="qutaForm.factoryList[index]"></QutaParameter>
                  </el-col>
                  <el-col :md="9" class="vg_ml_8">
                    <QutaProfit :formIndex="index" :qutaForm="qutaForm.factoryList[index]"> </QutaProfit>
                  </el-col>
                </el-row>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
        <el-row class="vg_mt_16 vd_bortop">
          <el-col>
            <inputUser v-if="qutaForm.stff_name" ref="userData" :isCookie="false" :stffForm="stffForm"></inputUser>
          </el-col>
        </el-row>
      </el-form>
    </el-form>
  </div>
</template>

<script>
import { get, getNoCatch, post, postNoCatch } from '@api/request';
import { rqtaAPI } from '@api/modules/rqta';
import { userAPI } from '@api/modules/user';
import { imgeAPI } from '@api/modules/imge';
import { suppAPI } from '@api/modules/supp';
import { optnAPI } from '@api/modules/optn';
import editHeader from '@/views/component/editHeader';
import inputUser from '@/views/component/inputUser';
import QutaAuxiliary from './Child/QutaAuxiliary.vue';
import imgPopover from '@/views/component/imgPopover';
import QutaRawMater from './Child/QutaRawMater.vue';
import QutaParameter from './Child/QutaParameter.vue';
import QutaProfit from './Child/QutaProfit.vue';
import QutaOffer from './Child/QutaOffer.vue';
import QutaPartList from './Child/QutaPartList.vue';
import { BigNumber } from 'bignumber.js';
import SearchTable from '@/components/SearchTableV3.vue';
import { theTradedFactoryProperties } from '@/views/DevelopManagement/FRqtaManage/frqta';
import { frqtaAPI } from '@api/modules/frqta';
import { cloneDeep } from 'lodash';

export default {
  name: 'qutaEditMain',
  components: {
    SearchTable,
    editHeader,
    inputUser,
    QutaAuxiliary, //辅助材料
    QutaRawMater, //原材料
    imgPopover,
    QutaParameter,
    QutaProfit,
    QutaPartList,
    QutaOffer
  },
  data() {
    return {
      theTradedFactoryProperties: cloneDeep(theTradedFactoryProperties),
      factoryList: [],
      erpSuppList: [],
      theTradedFactorySelection: [],
      editableTabsValue: '打样间',
      tabIndex: 1,
      rules: {
        smpl_frei_flag: [{ required: true, trigger: 'blur', message: ' ' }],
        quta_quoter_name: [{ required: true, trigger: 'change', message: ' ' }],
        quta_price: [{ required: true, trigger: 'blur', message: ' ' }],
        quta_pricer_name: [{ required: true, trigger: 'change', message: ' ' }],
        quta_prsalary: [{ required: true, trigger: 'blur', message: ' ' }]
      },
      qutaForm: {
        imge_id: null,
        imge_url: null,
        imge_urlO: null,
        smpl_frei_flag: '1',
        quta_quoter_name: null,
        quta_price: null,
        wagesList: [],
        tags: [],
        profitForm: {
          quta_profit_rate: null,
          smplPrice: null,
          priceIndTax: null,
          grossProMargin: null,
          samplePriceIncludingTax: null
        },
        factoryList: [],
        confirmFactoryList: []
      },
      isShow: true,
      btn: {},
      dataBody: {
        file: /\.(png|jpg|gif|jpeg)$/,
        cut: true,
        keep: false,
        x: 400,
        y: 400
      },
      imgForm: {
        imge_id: null,
        imge_url: null,
        imge_urlO: null
      },
      smplType: [
        { id: 1, label: '新款' },
        { id: 2, label: '老款' },
        { id: 3, label: '修改款' }
      ],
      uploadUrl: this.helper.modePrepend(imgeAPI.uploadImage),
      stffForm: {},
      stffType: [],
      stffType1: [],
      qutaCopy: [],
      title: '样品总控表',
      custList: [],
      contryName: null,
      loadingFlag: true,
      beloType: [],
      activeName: '0first',
      qutaSalaMapsToatl: 0,
      wegesForm: {},
      rateChangeFlag: true,
      rawPrice: 0,
      auxilPrice: 0,
      mtrlTotalPrice: 0,
      wagesPrice: 0,
      taxPrice: 0,
      smplMtrlCopy: [],
      qutaAccmtrlListCopy: [],
      partSelectChoose: [],
      partCopy: []
    };
  },
  created() {
    this.initData();
  },
  computed: {
    theTradedFactoryData() {
      return this.qutaForm.confirmFactoryList.filter(x => x.destroy_flag !== 1);
    },
    confirmFactorySuppAbbrList() {
      let map = this.qutaForm.confirmFactoryList.filter(x => x.destroy_flag !== 1).map(x => x.supp_abbr);
      return this.qutaForm.factoryList
        .filter(x => x.destroy_flag !== 1 && x.supp_abbr !== '打样间' && !map.includes(x.supp_abbr))
        .map(x => x.supp_abbr);
    }
  },
  watch: {},
  methods: {
    initData() {
      this.loadingFlag = true;
      this.getCustList();
      this.getqutaInfo();
      this.getStffType();
      this.getStffType1();
      this.getContry();
      this.getErpSupp();
    },
    //启用编辑
    openEdit() {
      this.isShow = false;
      this.$emit('isShow', this.isShow);
    },
    //撤销编辑
    closeEdit() {
      this.$confirm('是否撤销编辑?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.isShow = true;
          this.$emit('isShow', this.isShow);
          this.initData();
          this.$message({
            type: 'info',
            message: '已撤销编辑!'
          });
        })
        .catch(() => {});
    },
    //提交表单
    submit(formName) {
      this.$confirm('确认提交?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$refs[formName].validate(valid => {
            if (valid) {
              this.newSaveInfo();
            } else {
              console.log('error submit!');
              return false;
            }
          });
        })
        .catch(e => console.log(e));
    },
    newSaveInfo() {
      let editReqBody = {
        factoryInquiryForm_id: this.qutaForm.factoryInquiryForm_id,
        confirmFactoryList: this.qutaForm.confirmFactoryList.filter(x =>
          x.factoryinquiryform_confirmFactory_id ? true : !x.factoryinquiryform_confirmFactory_id && !x.destroy_flag
        ),
        factoryList: this.qutaForm.factoryList.filter(x => {
          x.listOfRawMaterials.forEach(item => {
            item.mtrb_bom_mater = JSON.stringify(item.mtrb_bom_mater);
          });
          return x.factoryinquiryform_factory_id ? true : !x.factoryinquiryform_factory_id && !x.destroy_flag;
        })
      };
      postNoCatch(frqtaAPI.editFactoryInquiryForm, editReqBody).then(({ data }) => {
        this.initData();
        this.isShow = true;
        this.$emit('isShow', this.isShow);
        this.$message({
          type: 'success',
          message: '保存成功!'
        });
      });
    },
    // 💩💩💩
    saveInfo() {
      let qutaForm = JSON.parse(JSON.stringify(this.qutaForm));
      let timeFlag = false;
      qutaForm.smpl_deil_time = parseInt(Number(qutaForm.smpl_deil_time) / 1000);
      qutaForm.quta_taxrate_mtrl = qutaForm.wagesList[0].tax_point;
      qutaForm.quta_taxrate_sala = qutaForm.wagesList[1].tax_point;
      qutaForm.quta_sala = {};
      qutaForm.quta_sala.quta_id = qutaForm.quta_id;
      qutaForm.quta_sala.rfid_cut_num = this.qutaForm.quta_sala.rfid_cut_num;
      qutaForm.quta_sala.quta_sala_cut = qutaForm.quta_sala_maps[0].sala;
      qutaForm.quta_sala.rfid_mase_time = this.qutaForm.quta_sala.rfid_mase_time;
      qutaForm.quta_sala.quta_sala_mase = qutaForm.quta_sala_maps[1].sala;
      qutaForm.quta_sala.nedl_phr = this.qutaForm.quta_sala.nedl_phr;
      qutaForm.quta_sala.quta_sala_nedl = qutaForm.quta_sala_maps[2].sala;
      qutaForm.quta_sala.skin_phr = this.qutaForm.quta_sala.skin_phr;
      qutaForm.quta_sala.quta_sala_skin = qutaForm.quta_sala_maps[3].sala;
      qutaForm.quta_sala.cutt_phr = this.qutaForm.quta_sala.cutt_phr;
      qutaForm.quta_sala.quta_sala_cutt = qutaForm.quta_sala_maps[4].sala;
      qutaForm.quta_sala.cott_phr = this.qutaForm.quta_sala.cott_phr;
      qutaForm.quta_sala.quta_sala_cott = qutaForm.quta_sala_maps[5].sala;
      qutaForm.quta_sala.sort_phr = this.qutaForm.quta_sala.sort_phr;
      qutaForm.quta_sala.quta_sala_sort = qutaForm.quta_sala_maps[6].sala;
      qutaForm.quta_sala.pack_phr = this.qutaForm.quta_sala.pack_phr;
      qutaForm.quta_sala.quta_sala_pack = qutaForm.quta_sala_maps[7].sala;
      qutaForm.quta_sala.quta_etc_time = this.qutaForm.quta_sala.quta_etc_time;
      qutaForm.quta_sala.quta_sala_etc = qutaForm.quta_sala_maps[8].sala;
      let quta_sala_time_range = [];
      for (let i = 0; i < qutaForm.quta_sala_maps.length; i++) {
        let num = new BigNumber(1);
        if (i === 0) {
          num = num.times(qutaForm.quta_sala_maps[i].time_range).toNumber();
        } else {
          num = num.times(qutaForm.quta_sala_maps[i].time_range).times(60).toFixed(4);
        }
        // TODO 不明意义代码 JQY所作
        // let num1 = Math.round(num);
        quta_sala_time_range.push(num);
        if (Number(qutaForm.quta_sala_maps[i].total) < 0) {
          timeFlag = true;
        }
      }
      if (timeFlag) {
        return this.$message.warning('每道工序的合计不可小于0');
      }
      qutaForm.quta_sala.quta_sala_time_range = quta_sala_time_range.join(',');
      // 往下面写就行了
      qutaForm.quta_mtrl_list = this.qutaForm.quta_mtrl_list; //原材料
      // JSON化字段数据
      qutaForm.quta_mtrl_list.forEach(item => {
        item.mtrb_bom_mater = JSON.stringify(item.mtrb_bom_mater);
      });
      qutaForm.quta_accmtrl_list = this.qutaForm.quta_accmtrl_list; //辅料
      qutaForm.quta_stam_num = this.qutaForm.quta_stam_num; //印片用量
      qutaForm.quta_stam_pru = this.qutaForm.quta_stam_pru; //印片单价
      qutaForm.quta_emcd_num = this.qutaForm.quta_emcd_num; //电绣片数
      qutaForm.quta_emcd_pru = this.qutaForm.quta_emcd_pru; //电绣 片数单价
      qutaForm.quta_emcd_pnum = this.qutaForm.quta_emcd_pnum; //电绣 贴数
      qutaForm.quta_emcd_ppru = this.qutaForm.quta_emcd_ppru; //电绣 贴数 单价
      qutaForm.quta_emcd_hnum = this.qutaForm.quta_emcd_hnum; //电绣 针数
      qutaForm.quta_emcd_ppru = this.qutaForm.quta_emcd_ppru; //电绣 针数 单价
      qutaForm.quta_ctn_prsm = this.qutaForm.quta_ctn_prsm; //纸箱 平方价格
      qutaForm.quta_bag_prkg = this.qutaForm.quta_bag_prkg; //塑料袋 公斤价格
      qutaForm.quta_etc_pr = this.qutaForm.quta_etc_pr; //其他辅料费用
      if (!qutaForm.supp_id) {
        qutaForm.supp_id = 0;
      }
      if (!qutaForm.quta_pricer_name) {
        qutaForm.quta_pricer_name = 0;
      }
      if (!qutaForm.quta_procer) {
        qutaForm.quta_procer = 0;
      }
      if (!qutaForm.quta_pridate) {
        qutaForm.quta_pridate = 0;
      } else {
        qutaForm.quta_pridate = this.helper.getNewDate(qutaForm.quta_pridate);
      }
      qutaForm.quta_total = qutaForm.profitForm.priceIndTax;
      qutaForm.quta_total2 = qutaForm.profitForm.samplePriceIncludingTax;
      qutaForm.quta_price = this.taxPrice;
      qutaForm.quta_prsalary = this.qutaSalaMapsToatl;
      this.smplMtrlCopy = this.smplMtrlCopy.filter(item =>
        qutaForm.quta_mtrl_list.every(item1 => item.quta_mtrl_id !== item1.quta_mtrl_id)
      );
      for (let i = 0; i < this.smplMtrlCopy.length; i++) {
        this.smplMtrlCopy[i].destroy_flag = 1;
      }
      this.qutaAccmtrlListCopy = this.qutaAccmtrlListCopy.filter(item =>
        qutaForm.quta_accmtrl_list.every(item1 => item.quta_mtrl_id !== item1.quta_mtrl_id)
      );
      for (let i = 0; i < this.qutaAccmtrlListCopy.length; i++) {
        this.qutaAccmtrlListCopy[i].destroy_flag = 1;
      }
      this.partCopy = this.partCopy.filter(item => qutaForm.rqta_part_list.every(item1 => item.quta_part_id !== item1.quta_part_id));
      for (let i = 0; i < this.partCopy.length; i++) {
        this.partCopy[i].destroy_flag = 1;
      }
      qutaForm.quta_accmtrl_list = qutaForm.quta_accmtrl_list.concat(this.qutaAccmtrlListCopy);
      qutaForm.quta_mtrl_list = qutaForm.quta_mtrl_list.concat(this.smplMtrlCopy);
      qutaForm.rqta_part_list = qutaForm.rqta_part_list.concat(this.partCopy);
      qutaForm.tags = (qutaForm.tags || []).join(',');
      post(rqtaAPI.editRqta, qutaForm)
        .then(res => {
          if (res.data.code === 0) {
            this.$message({
              type: 'success',
              message: '保存成功'
            });
            this.isShow = true;
            this.$emit('isShow', this.isShow);
            this.initData();
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
            // this.initData()
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //取消
    cancel() {
      this.$confirm('确定取消新增?', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        type: 'warning'
      })
        .then(() => {
          this.resetForm('qutaForm');
          this.$router.go(-1);
          this.$message({
            type: 'info',
            message: '已取消新增!'
          });
        })
        .catch(() => {});
    },
    // 刷新按钮
    buttonRefresh() {
      this.initData();
    },
    // 配件新增
    addPartList() {
      let item = {
        key: this.qutaForm.rqta_part_list.length,
        quta_part_name: null,
        quta_part_spec: null,
        quta_part_price: null,
        quta_part_weight: null
      };
      this.qutaForm.rqta_part_list.push(item);
    },
    // 配件删除
    delPartList() {
      if (this.partSelectChoose.length === 0) return this.$message.warning('至少选择一条数据');
      let temp = [];
      this.partSelectChoose.forEach(item => temp.push(item.key));
      temp = temp.sort((a, b) => {
        return b - a;
      });
      for (let j of temp) {
        this.qutaForm.rqta_part_list.splice(j, 1);
      }
      this.qutaForm.rqta_part_list.forEach((item, index) => (item.key = index));
      this.$refs.QutaPartList.getTotalPrice();
      this.rateChange();
    },
    // 配件信息勾选框
    handleSelectionPart(val) {
      this.partSelectChoose = JSON.parse(JSON.stringify(val));
    },
    // 塑料袋长度更换
    smplBagLChange() {
      this.$refs.QutaAuxiliary.emcdNumPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 塑料袋宽度更换
    smplBagWChange() {
      this.$refs.QutaAuxiliary.emcdNumPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 纸箱长度更换
    smplBoxLChange() {
      this.$refs.QutaAuxiliary.freightPriceChange(1);
      this.$refs.QutaAuxiliary.cartonPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 纸箱宽度更换
    smplBoxWChange() {
      this.$refs.QutaAuxiliary.freightPriceChange(1);
      this.$refs.QutaAuxiliary.cartonPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 纸箱高度更换
    smplBoxHChange() {
      this.$refs.QutaAuxiliary.freightPriceChange(1);
      this.$refs.QutaAuxiliary.cartonPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 装箱数更换
    qpcChange() {
      this.$refs.QutaAuxiliary.freightPriceChange(1);
      this.$refs.QutaAuxiliary.cartonPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 装袋数更换
    smplQpbChange() {
      this.$refs.QutaAuxiliary.emcdNumPriceChange(1);
      this.$refs.QutaAuxiliary.getTotalPrice();
    },
    // 运费更改计算
    containFreight(val) {
      this.$refs.QutaAuxiliary.freightPriceChange(0);
    },
    // 原材料计算总价
    getTotalPriceTo(val) {
      this.rawPrice = Number(this.helper.haveFour(val));
      let num = new BigNumber(0);
      num = num.plus(this.rawPrice).plus(this.auxilPrice);
      this.mtrlTotalPrice = num.toNumber();
      this.wagesListChage();
    },
    // 辅助材料计算总价
    getTotalPrice(val) {
      this.auxilPrice = Number(this.helper.haveFour(val));
      let num = new BigNumber(0);
      num = num.plus(this.rawPrice).plus(this.auxilPrice);
      this.mtrlTotalPrice = num.toNumber();
      this.wagesListChage();
    },
    // 利率变化
    rateChange() {
      // this.rateChangeFlag = false;
      let profitForm = {};
      let num1 = new BigNumber(1);
      let num2 = new BigNumber(0);
      let num3 = new BigNumber(1);
      let num4 = new BigNumber(0); //配件价格
      let samplePriceIncludingTax = new BigNumber(0); // 样品含税价格
      if (this.qutaForm.rqta_part_list) {
        this.qutaForm.rqta_part_list.forEach(item => {
          num4 = num4.plus(item.quta_part_price ? item.quta_part_price : 0);
        });
      }
      num4 = num4.toNumber();
      // 1 * 主表利润百分比 * 含税金额合计
      num1 = num1.times(this.qutaForm.quta_profit_rate).times(this.wegesForm.totalFour).toNumber();
      // 产品合计价格 = (1 * 主表利润百分比 * 含税金额合计) + 含税金额合计 +  配件1价格 + 配件2价格 + 配件价格
      num2 = num2
        .plus(num1)
        .plus(this.wegesForm.totalFour)
        .plus(this.qutaForm.parts_price_two)
        .plus(this.qutaForm.parts_price_one)
        .plus(num4)
        .toNumber();
      // 样品含税价格
      samplePriceIncludingTax = new BigNumber(0)
        .plus(num1)
        .plus(this.wegesForm.totalFour)
        .plus(this.qutaForm.parts_price_two)
        .plus(this.qutaForm.parts_price_one)
        .toNumber();
      //1 * ((1 * 主表利润百分比 * 含税金额合计) + 含税金额合计 + 配件1价格 + 配件2价格 + 配件价格) / 成本价
      num3 = num3.times(num2).div(this.wegesForm.totalTwo).toNumber();
      profitForm.smplPrice = this.helper.haveFour(num1);
      profitForm.priceIndTax = this.helper.haveFour(num2);
      profitForm.samplePriceIncludingTax = this.helper.haveFour(samplePriceIncludingTax);
      profitForm.grossProMargin = this.helper.reservedDigits(num3);
      this.qutaForm.profitForm = profitForm;
      this.taxPrice = profitForm.priceIndTax;
      this.$nextTick(() => {
        this.rateChangeFlag = true;
      });
    },
    // 参数计算总数
    taxPointChangeTotal(val) {
      this.wegesForm = val;
      this.rateChange();
    },
    // 参数信息变化
    taxPointChange(val) {
      this.qutaForm.wagesList[val].tax_point = this.helper.reservedDigits(this.qutaForm.wagesList[val].tax_point);
      this.wagesListChage();
    },
    // 参数信息变化修改值
    wagesListChage() {
      for (let i in this.qutaForm.wagesList) {
        if (i === '0') {
          this.qutaForm.wagesList[i].cost_price = this.helper.haveFour(this.mtrlTotalPrice);
        } else if (i === '1') {
          this.qutaForm.wagesList[i].cost_price = this.helper.haveFour(this.qutaSalaMapsToatl);
        }
        let num1 = new BigNumber(1);
        num1 = num1.times(this.qutaForm.wagesList[i].cost_price).times(this.qutaForm.wagesList[i].tax_point).toNumber();
        let num2 = new BigNumber(0);
        num2 = num2.plus(num1).minus(this.qutaForm.wagesList[i].cost_price).toNumber();
        this.qutaForm.wagesList[i].tax_price = this.helper.haveFour(num1);
        this.qutaForm.wagesList[i].tax_toatl = this.helper.haveFour(num2);
      }
      this.rateChange();
    },
    // 报价工资系数单价变化
    salaChange(val) {
      this.qutaSalaMapsToatl = val;
      this.qutaSalaMapsChange();
    },
    // 获取委托人
    getStffType() {
      get(userAPI.getAllUsersV1, { dept_ids: '2,17' })
        .then(res => {
          if (res.data.code === 0) {
            let stffType = res.data.data;
            let map = new Map();
            for (let item of stffType) {
              map.set(item.stff_name, item);
            }
            stffType = [...map.values()];
            this.stffType = stffType;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取委托人
    getStffType1() {
      get(userAPI.getAllUsersV1, { dept_ids: '10' })
        .then(res => {
          if (res.data.code === 0) {
            let stffType1 = res.data.data;
            let map = new Map();
            for (let item of stffType1) {
              map.set(item.stff_name, item);
            }
            stffType1 = [...map.values()];
            this.stffType1 = stffType1;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    // 获取打样部门
    getContry() {
      get(optnAPI.getOptnByPermId, { perm_id: 10009 })
        .then(res => {
          if (res.data.code === 0) {
            let beloType = res.data.data.form.optn_cntt_list;
            for (let item of beloType) {
              item.param2 = Number(item.param2);
            }
            this.beloType = beloType;
          }
        })
        .catch(() => {});
    },
    getErpSupp() {
      getNoCatch(frqtaAPI.getErpSupplierList).then(({ data }) => {
        this.erpSuppList = data;
      });
    },
    // 获取客户国家
    getCustList() {
      get(suppAPI.getSuppsV1)
        .then(res => {
          if (res.data.code === 0) {
            this.custList = res.data.data;
          } else {
            let mg = res.data.msg;
            let tp = 'error';
            this.$message({ message: mg, type: tp });
          }
        })
        .catch(res => {
          let mg = res.data.msg;
          let tp = 'error';
          this.$message({ message: mg, type: tp });
        });
    },
    //表单重置
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 获取表单信息
    getqutaInfo() {
      this.qutaForm.factoryInquiryForm_id = this.$route.query.form_id;
      getNoCatch(frqtaAPI.getFactoryInquiryFormById, { factoryInquiryForm_id: this.qutaForm.factoryInquiryForm_id }).then(res => {
        this.qutaForm = res.data.form;
        if (this.qutaForm.tags) this.qutaForm.tags = this.qutaForm.tags.split(',');
        this.qutaForm.quta_deli_time = Number(this.qutaForm.quta_deli_time) * 1000;
        if (this.qutaForm.smpl_deil_time) this.qutaForm.smpl_deil_time = this.qutaForm.smpl_deil_time * 1000;
        let urlEng = JSON.parse(JSON.stringify(this.qutaForm.imge_url));
        this.qutaForm.imge_id = 1;
        let updateTime = JSON.parse(JSON.stringify(new Date().getTime()));
        this.qutaForm.imge_url = this.helper.picUrl(urlEng, 'm', updateTime);
        this.qutaForm.imge_urlO = this.helper.picUrl(urlEng, 'l', updateTime);
        this.qutaForm.factoryList.forEach(item => {
          item.listOfRawMaterials.forEach(subItem => {
            subItem.mtrb_bom_mater = JSON.parse(subItem.mtrb_bom_mater || '{}');
            subItem.quta_contain_lossrate = this.helper.haveSix(subItem.quta_mtrl_lossrate * subItem.quta_mtrl_consume);
          });
        });
        this.btn = res.data.btn;
        this.stffForm.stff_name = this.qutaForm.stff_name;
        this.stffForm.dept_name = this.qutaForm.dept_name;
        this.stffForm.dept_team_name = this.qutaForm.dept_team_name;
        this.stffForm.user_id = this.qutaForm.user_id;
        this.stffForm.dept_id = this.qutaForm.dept_id;
        this.stffForm.stff_id = this.qutaForm.stff_id;
        this.stffForm.create_time = this.qutaForm.create_time;
        setTimeout(() => {
          if (this.qutaForm.create_time === this.qutaForm.update_time) {
            this.isShow = false;
            this.$emit('isShow', this.isShow);
          }
          this.loadingFlag = false;
        }, 500);
      });
    },
    // 计算运费
    freightPriceChange(val) {
      let valPrice = new BigNumber(0);
      let num1 = new BigNumber(1);
      let num2 = new BigNumber(0);
      if (this.qutaForm.smpl_frei_flag !== '0') {
        num1 = num1
          .times(this.qutaForm.smpl_box_l)
          .div(100)
          .times(this.qutaForm.smpl_box_w)
          .div(100)
          .times(this.qutaForm.smpl_box_h)
          .div(100)
          .times(this.qutaForm.smpl_freight)
          .div(this.qutaForm.smpl_qpc)
          .toNumber();
        if (Number.isFinite(num1)) {
          valPrice = valPrice.plus(num1).plus(val);
          num1 = this.helper.haveFour(num1);
          this.$refs.QutaAuxiliary.freightPrice = num1;
        } else {
          valPrice = valPrice.plus(val);
        }
      } else {
        valPrice = valPrice.plus(val);
      }
      for (let i = 0; i < this.qutaForm.quta_accmtrl_list.length; i++) {
        let temp = new BigNumber(1);
        temp = temp
          .times(this.qutaForm.quta_accmtrl_list[i].quta_mtrl_consume)
          .times(this.qutaForm.quta_accmtrl_list[i].mtrl_price)
          .times(this.qutaForm.quta_accmtrl_list[i].quta_mtrl_lossrate);
        num2 = num2.plus(temp);
      }
      valPrice = valPrice.plus(num2).toNumber();
      this.auxilPrice = valPrice;
      this.$refs.QutaAuxiliary.totalPrice = this.helper.haveFour(valPrice);
      this.qutaSalaMapsChange();
    },
    // 计算电绣金额
    emcdTotalPriceChnage(val) {
      let valPrice = new BigNumber(0);
      let num1 = new BigNumber(1); //针数
      let num2 = new BigNumber(1); //片数
      let num3 = new BigNumber(1); //贴数
      let num4 = new BigNumber(0);
      if (Number(this.qutaForm.quta_emcd_hnum) % 1000 !== 0) {
        num1 = num1.times(this.qutaForm.quta_emcd_hnum).idiv(1000).plus(1);
      } else {
        num1 = num1.times(this.qutaForm.quta_emcd_hnum).div(1000);
      }
      num1 = num1.times(1000).times(this.qutaForm.quta_emcd_hpru).toNumber();
      num2 = num2.times(this.qutaForm.quta_emcd_num).times(this.qutaForm.quta_emcd_pru).toNumber();
      num3 = num3.times(this.qutaForm.quta_emcd_pnum).times(this.qutaForm.quta_emcd_ppru).toNumber();
      if (num1 >= num2) {
        num4 = num4.plus(num3).plus(num1).toNumber();
      } else {
        num4 = num4.plus(num3).plus(num2).toNumber();
      }
      if (Number.isFinite(num4)) {
        if (Number(this.qutaForm.quta_emcd_price) === 0) {
          valPrice = valPrice.plus(num4).plus(val);
        } else {
          valPrice = valPrice.plus(this.qutaForm.quta_emcd_price).plus(val);
        }
        num4 = this.helper.haveFour(num4);
      } else {
        if (Number(this.qutaForm.quta_emcd_price) === 0) {
          valPrice = valPrice.plus(val);
        } else {
          valPrice = valPrice.plus(val).plus(this.qutaForm.quta_emcd_price);
        }
      }
      if (Number(this.qutaForm.quta_emcd_price) === 0) {
        this.qutaForm.quta_emcd_price = num4;
      }
      valPrice = valPrice.toNumber();
      this.freightPriceChange(this.helper.haveFour(valPrice));
    },
    // 计算塑料袋金额
    emcdNumPriceChange(val) {
      let valPrice = new BigNumber(0);
      if (Number(this.qutaForm.smpl_bag_l) > 0 && Number(this.qutaForm.smpl_bag_w) > 0) {
        let num1 = new BigNumber(1);
        num1 = num1.times(this.qutaForm.smpl_bag_l).div(100).times(this.qutaForm.smpl_bag_w).div(100).times(0.08);
        let num2 = new BigNumber(1);
        num2 = num2.times(num1).times(this.qutaForm.quta_bag_prkg).div(this.qutaForm.smpl_qpb).toNumber();
        if (Number.isFinite(num2)) {
          valPrice = valPrice.plus(num2).plus(val);
          num2 = this.helper.haveFour(num2);
          this.$refs.QutaAuxiliary.bagPrkgPrice = num2;
        } else {
          valPrice = valPrice.plus(val);
          this.$refs.QutaAuxiliary.bagPrkgPrice = '0.0000';
        }
      } else {
        valPrice = valPrice.plus(val);
        this.$refs.QutaAuxiliary.bagPrkgPrice = '0.0000';
      }
      valPrice = valPrice.toNumber();
      this.emcdTotalPriceChnage(this.helper.haveFour(valPrice));
    },
    // 计算报价工资总数
    qutaSalaMapsChange() {
      let price = new BigNumber(0);
      for (let i = 0; i < this.qutaForm.quta_sala_maps.length; i++) {
        let num1 = new BigNumber(0);
        let num2 = new BigNumber(0);
        let total = new BigNumber(1);
        if (i === 0) {
          if (Number(this.qutaForm.quta_sala_maps[i].time_range) === 0) {
            num1 = num1.plus(this.qutaForm.quta_sala_maps[i].time);
          } else {
            num1 = num1.plus(this.qutaForm.quta_sala_maps[i].time_range);
          }
          total = total.times(num1).times(this.qutaForm.quta_sala_maps[i].sala).toNumber();
        } else {
          if (Number(this.qutaForm.quta_sala_maps[i].time_range) === 0) {
            num1 = num1.plus(this.qutaForm.quta_sala_maps[i].time);
          } else {
            num1 = num1.plus(this.qutaForm.quta_sala_maps[i].time_range);
          }
          total = total.times(num1).times(this.qutaForm.quta_sala_maps[i].sala).toNumber();
        }
        this.$set(this.qutaForm.quta_sala_maps[i], 'total', this.helper.haveFour(total));
        price = price.plus(this.qutaForm.quta_sala_maps[i].total);
      }
      price = this.helper.haveFour(price.toNumber());
      this.qutaSalaMapsToatl = price;
      this.$refs.QutaOffer.totalPrice = this.qutaSalaMapsToatl;
      this.getTotalPriceTo(this.rawPrice);
    },

    removeTab(targetName) {
      let find = this.qutaForm.factoryList.find(item => item.supp_abbr === targetName);
      if (find) find.destroy_flag = 1;
      this.editableTabsValue = '打样间';
      this.activeName = '0first';
    },
    tabClick(tab) {
      this.activeName = tab.index + 'first';
    },
    addTab(targetName) {
      let temp = [];
      let copyData = this.qutaForm.factoryList.find(x => x.supp_abbr === '打样间');
      targetName.forEach(item => {
        let find = this.qutaForm.factoryList.find(x => x.supp_abbr === item);
        if (find) {
          temp.push(find.supp_abbr);
        } else {
          let copy = cloneDeep(copyData);
          copy.supp_abbr = item;
          copy.factoryinquiryform_factory_id = null;
          this.qutaForm.factoryList.push(copy);
        }
      });
      if (temp.length > 0) {
        this.$message({
          message: temp.toString() + '已存在!',
          type: 'warning'
        });
      }
      this.factoryList = [];
    },
    addConfirmFactory() {
      this.qutaForm.confirmFactoryList.push({
        supp_abbr: null, //工厂简称
        material_prices: null, //面辅料价格
        labor_wages: null, //人工工资
        total_tax_amount: null, //税额合计
        tax_inclusive_amount: null, //含税金额
        destroy_flag: 0 //删除标识
      });
    },
    handleSelectionChange(val) {
      this.theTradedFactorySelection = val;
    },
    deleteConfirmFactory() {
      this.theTradedFactorySelection.forEach(item => (item.destroy_flag = 1));
    },
    suppAbbrChange(val, row) {
      let find = this.qutaForm.factoryList.find(x => x.supp_abbr === val);
      if (find) {
        row.material_prices = find.cost_price_mtrl;
        row.labor_wages = find.cost_price_rate;
        row.tax_inclusive_amount = new BigNumber(find.tax_price_mtrl).plus(find.tax_price_rate).toNumber();
        row.total_tax_amount = new BigNumber(find.tax_toatl_mtrl).plus(find.tax_toatl_rate).toNumber();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

// .avatar-uploader ::v-deep .el-upload--text {
//   width: 136px;
//   height: 136px;
// }
.avatar-uploader .el-upload:hover {
  border-color: $color-primary;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: $color-uploader-icon;
  width: 136px;
  height: 136px;
  line-height: 136px;
  text-align: center;
}

.avatar {
  width: 136px;
  height: 136px;
  display: block;
}

.vd_bortop {
  border-top: #dcdfe6 solid 1px;
  padding-top: 20px;
}

.vd_mrt1 {
  margin-top: 1px;
}

.vd_edhea {
  position: relative;
}

.vd_export {
  position: absolute;
  top: 0;
  left: 65px;
}

.vd_solidDiv {
  height: 1px;
  border: none;
  background-color: #dcdfe6;
  margin: 20px 0 20px 0;
}

.vd_solidDiv1 {
  height: 1px;
  border: none;
  border-top: 1px dashed #dcdfe6;
  margin: 20px 0 20px 0;
}

.vd_but {
  margin-bottom: 10px;
}

::v-deep .el-upload--text {
  height: 200px;
  width: 200px;
}

::v-deep .el-upload-dragger {
  height: 200px;
  width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
